import React from "react";
import { BnbLabel } from "../../../utils/labels";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as Type from "../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { useBnbSelector } from "../../../redux/store";
import DisclaimerContainer from "../common/disclaimer/DisclaimerContainer";
import FinanceToggle from "../common/FinanceToggle";
import ModelFilters from "./filters/ModelFilters";
import GradeList from "./GradeList";
import Container from "../common/styles/Container";
import * as Styles from "./styles/Model";
import { isRTL } from "../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import { hasEquipmentFilter } from "../../../utils/typedUtils";
import useEquipmentModelStepFilter from "../../../hooks/model/useEquipmentModelStepFilter";
import EquipmentModelStepFilter from "./filters/EquipmentModelStepFilter";
import { useBreakpoint } from "../../../../../../common-deprecated/themes/common";

const ModelOverview = (): JSX.Element => {
    const model = useBnbSelector((state) => state.model);
    const modelFilter = useBnbSelector((state) => state.modelFilter);
    const modelHasActiveFilters = useBnbSelector((state) => state.bnbSettings.modelHasActiveFilters);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const modelHasEquipmentFilter = useBnbSelector(hasEquipmentFilter);

    const { filteredGrades, selectFilterItem, deselectFilterItem, itemIsSelected } = useEquipmentModelStepFilter();

    const isMobile = useBreakpoint("down", "sm");
    const matchingModelFilterGrades = model.grades
        ? model.grades.filter((grade) =>
              modelFilter.filteredGrades.some((filteredGrade) => filteredGrade.id === grade.id),
          )
        : modelFilter.filteredGrades;

    return (
        <>
            {modelHasActiveFilters && <ModelFilters />}
            {modelHasEquipmentFilter && (
                <EquipmentModelStepFilter
                    selectFilterItem={selectFilterItem}
                    deselectFilterItem={deselectFilterItem}
                    itemIsSelected={itemIsSelected}
                    grade={filteredGrades[0]}
                />
            )}

            <Styles.Wrapper tinted={modelHasActiveFilters || modelHasEquipmentFilter}>
                <Container py={3} mt={modelHasActiveFilters ? { lg: 5 } : null}>
                    <Flex.Row pb={modelHasActiveFilters ? 2 : 0} mb={3}>
                        <Flex.Col
                            width={{ xs: 1, md: 1 / 2, lg: 8 / 12 }}
                            textAlign={isRTL(commonSettings) ? "right" : "left"}
                        >
                            {!modelHasActiveFilters && !modelHasEquipmentFilter && (
                                <Type.H2 as={modelHasActiveFilters ? "h2" : "h1"} headingType="sub-epsilon" mb={0}>
                                    <BnbLabel label="chooseYourGrade" params={{ model: model.name }} />
                                </Type.H2>
                            )}
                        </Flex.Col>
                        <Flex.Col
                            display="flex"
                            justifyContent="flex-end"
                            width={{ xs: 1, md: 1 / 2, lg: 4 / 12 }}
                            textAlign={{ xs: "left", md: "right" }}
                            px={{ md: 3 }}
                            pt={{ xs: 3, md: 0 }}
                        >
                            <FinanceToggle
                                isFullWidth={isMobile}
                                modelCode={modelHasActiveFilters ? modelFilter.internalCode : model.internalCode}
                            />
                        </Flex.Col>
                    </Flex.Row>
                    <GradeList
                        modelId={model.id}
                        grades={modelHasActiveFilters ? matchingModelFilterGrades : filteredGrades}
                        modelName={model.name}
                    />
                    <DisclaimerContainer hasDarkBackground />
                </Container>
            </Styles.Wrapper>
        </>
    );
};

export default ModelOverview;
